import cx from 'classnames';
import {
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
    PHONE_VERIFICATION_I_WANT_YOU_TO_CALL_ME,
    PHONE_VERIFICATION_VERIFY_SMS_CHANGE_BTN,
    PHONE_VERIFICATION_VERIFY_SMS_RESEND_TOKEN,
    PHONE_VERIFICATION_VERIFY_SMS_SENDING,
    PHONE_VERIFICATION_VERIFY_SMS_SMS_TOKEN_LABEL,
    PHONE_VERIFICATION_VERIFY_SMS_SMS_WAS_SENT_TO_number_btn,
    PHONE_VERIFICATION_VERIFY_SMS_SUBMIT,
    PHONE_VERIFICATION_VERIFY_SMS_TITLE,
    PHONE_VERIFICATION_WE_CAN_CALL_YOU,
} from 'mk/autogenerated/translations/VerifySmsTokenStep.5e73b2c66027902ccc6dad48f80b5634'
import Btn, { BtnType } from 'mk2/components/Btn';
import InputField from 'mk2/components/forms/InputField';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import Interpolate from 'mk2/components/Interpolate';
import { Mode, TOKEN_FORM_NAME } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import { FormErrors } from 'redux-form';
import styles from './VerifySmsTokenStep.mscss';

interface OwnProps {
    className?: string;
    prefix: string;
    phoneNumber: string;
    limitReached: boolean;
    sending: boolean;
    mode: Mode;

    onVerifySmsToken(token: string, mode: Mode, fullPhoneNumber: string);
    onResendSmsToken();
    onCallMe();
    onChangeNumber();

    onStoreEvent();
}

type Props = OwnProps;

interface TokenValues {
    token: string;
}

const validate = (values: TokenValues) => {
    const errors: FormErrors<TokenValues> = {};

    if (!values.token) {
        errors.token = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    }

    return errors;
};

class VerifySmsTokenStep extends React.Component<Props & MKReduxFormInjectedProps<TokenValues, Props>> {

    public componentDidMount() {
        this.props.onStoreEvent();
    }

    public render() {
        const {
            className, limitReached, onResendSmsToken, prefix, phoneNumber,
            onChangeNumber, onCallMe, sending, handleSubmit,
        } = this.props;

        return (
            <div className={cx(styles.VerifySmsTokenStep, className)}>
                <h1 className={styles.VerifySmsTokenStep__title}>
                    {PHONE_VERIFICATION_VERIFY_SMS_TITLE}
                </h1>

                <div className={styles.VerifySmsTokenStep__content}>
                    <Interpolate
                        i18nKey={PHONE_VERIFICATION_VERIFY_SMS_SMS_WAS_SENT_TO_number_btn}
                        number={(
                            <strong>
                                {prettyNumber(prefix + phoneNumber)}
                            </strong>
                        )}
                        btn={(
                            <button className={styles.VerifySmsTokenStep__link} onClick={onChangeNumber}>
                                {PHONE_VERIFICATION_VERIFY_SMS_CHANGE_BTN}
                            </button>
                        )}
                    />
                    <br />
                    {!limitReached && (
                        <Btn
                            type={BtnType.Link}
                            label={interpolate(sending ? PHONE_VERIFICATION_VERIFY_SMS_SENDING : PHONE_VERIFICATION_VERIFY_SMS_RESEND_TOKEN)}
                            onClick={onResendSmsToken}
                            icon={sending ? 'fa-spin fa-spinner' : undefined}
                            disabled={sending}
                        />
                    )}
                </div>

                {limitReached && (
                    <div className={styles.VerifySmsTokenStep__announcement}>
                        {PHONE_VERIFICATION_WE_CAN_CALL_YOU}
                        <Btn
                            type={BtnType.Link}
                            label={PHONE_VERIFICATION_I_WANT_YOU_TO_CALL_ME}
                            onClick={onCallMe}
                        />
                    </div>
                )}

                <form className={styles.VerifySmsTokenStep__form} onSubmit={handleSubmit}>
                    <InputField
                        name="token"
                        type="text"
                        label={PHONE_VERIFICATION_VERIFY_SMS_SMS_TOKEN_LABEL}
                        marginLeft={false}
                    />

                    <SubmitButton
                        className={styles.VerifySmsTokenStep__form__submit}
                        label={PHONE_VERIFICATION_VERIFY_SMS_SUBMIT}
                        icon="fa-paper-plane"
                        formName={TOKEN_FORM_NAME}
                    />
                </form>
            </div>
        );
    }
}

export default mkReduxFormNew<TokenValues, Props>({
    formName: TOKEN_FORM_NAME,
    onValidate: (values) => validate(values),
    onSave: (values, props) => props.onVerifySmsToken(values.token, props.mode, props.prefix + props.phoneNumber),
    disableDirtyCheck: true,
})(VerifySmsTokenStep);

export function prettyNumber(phone) {
    if (phone.substring(0, 3) !== '+42') {
        // don't pretty format foreign numbers
        return phone;
    }
    return `${phone.substring(0, 4)} ${phone.substring(4, 7)} ${phone.substring(7, 10)} ${phone.substring(10)}`;
}
